import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { ITCIHook, ITCIHookStatus, ITCINotification, ITCIRule, SERVICE_URLS } from "@tci/common";
import { Observable } from "rxjs";

@Injectable()
export class NgAlertService {
    private static instance: NgAlertService = null;

    public static getInstance(http: Http) {
        if (!NgAlertService.instance) {
            NgAlertService.instance = new NgAlertService(http);
        }
        return NgAlertService.instance;
    }

    constructor(private http: Http) {
    }

    public getRuleList(appId: string): Observable<ITCIRule[]> {
        const url = `${SERVICE_URLS.ALERT_LIST}` + (appId ? `?appId=${appId}` : "");
        return this.http.get(url)
            .map(response => <ITCIRule[]>response.json())
            .catch(err => Observable.throw(err));
    }

    public getHookList(): Observable<ITCIHook[]> {
        const url = `${SERVICE_URLS.ALERT_HOOK}/list`;
        return this.http.get(url)
            .map(response => <ITCIHook[]>response.json())
            .catch(err => Observable.throw(err));
    }

    public getHookStatus(hookId: string): Observable<ITCIHookStatus> {
        const url = `${SERVICE_URLS.ALERT_HOOK}/${hookId}/status`;
        return this.http.get(url)
            .map(response => <ITCIHookStatus>response.json())
            .catch(err => Observable.throw(err));
    }

    public getNotificationList(appId: string): Observable<ITCINotification[]> {
        const url = `${SERVICE_URLS.ALERT_NOTIFICATIONS}` + (appId ? `?appId=${appId}` : "");
        return this.http.get(url)
            .map(response => <ITCINotification[]>response.json())
            .catch(err => Observable.throw(err));
    }

    public addAppRule(appId: string, ruleId: string): Observable<boolean> {
        const url = `${SERVICE_URLS.ALERT_ADD}` + `/${ruleId}` + (appId ? `?appId=${appId}` : "");
        return this.http.put(url, null)
            .map(() => true)
            .catch(() => Observable.throw(false));
    }

    public deleteAppRule(appId: string, ruleId: string): Observable<boolean> {
        const url = `${SERVICE_URLS.ALERT_DELETE}` + `/${ruleId}` + (appId ? `?appId=${appId}` : "");
        return this.http.delete(url)
            .map(() => true)
            .catch(() => Observable.throw(false));
    }
}
